import React, { useEffect } from "react";
import locationMark from "../images/location-mark.svg";
import logo from "../images/ibottonline_prashant-logo.png";

const UpcomingTransaction = () => {

    // Fetch details
    useEffect(() => {
        
    }, []);

    return (
        <div className="contain-wrap-ib">
            <style>{`
            *{
                box-sizing: border-box;
                margin: 0px;
                padding: 0px;
            }
            html, body{
                margin: 0px;
                padding: 0px;
                width: 100%;
                height: 100%;
                font-family: "Poppins", sans-serif;
            }
            .contain-wrap-ib{
                width: 100%;
                height: calc(100% - 15px);
                padding: 15px;
                background: #F6F8FC;
            }
            .contain-wrap-ib p {
                padding: 6px 0px;
                text-align: center;
                font-size: 12px;
                color: #666984;
            }
            .inner-contain-ib{
                background: #FFF;
                height: 100%;
                border-radius: 8px;
                border: 1px solid #D1DAEB;
                padding: 30px;
                display: flex;
                flex-direction: column;
                align-items: stretch;
                justify-content: space-around
            }
            .logo-cntr,
            .location-pin{
                // text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .logo-cntr img{
                width: 180px;
            }
            .success-msg{
                text-align: center;
            }
            .success-msg p{
                font-size: 24px;
                font-family: "Poppins", sans-serif;
            }
            .location-pin p{
                font-size: 24px;
                font-family: "Poppins", sans-serif;
            }
            .location-pin img{
                margin-right: 10px;
            }
            .btn-estimate{
                display: flex;
                width: 100%;
                justify-content: center; 
            }
            .btn-estimate button{
                background:#091DF2;
                width: 280px;
                text-align: center;
                margin: 20px auto;
                font-size: 16px;
                font-weight: 400;
                color: #FFF;
                border-radius: 4px;
                padding: 9px;
                cursor: pointer;
                font-family: "Poppins", sans-serif;
                text-decoration: none;
                margin: 0px auto;
            }
            `}</style>
            <div className="inner-contain-ib">
            <div className="logo-cntr">
                <img src={logo} alt="Logo" />
            </div>
            <div className="success-msg">
                <p>Congratulations on your<br/> upcoming transaction for:</p>
            </div>
            <div className="location-pin">
                <img src={locationMark} alt="Location" /> 
                <p>Santa Ana, CA, 92707</p>
            </div>
            <div className="btn-estimate">
                <button>Your Estimated Closing Costs </button>
            </div>
            </div>
            <p> 2025 Turning Point Software. All rights reserved.</p>
        </div>
    );
};

export default UpcomingTransaction;